import React, { useRef } from 'react';
import classNames from 'classnames';
import useWindowResize from '../hooks/UseWindowResize';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

import { observer } from 'mobx-react-lite';
import { store } from '../Store';
import { CloseButton } from './CloseButton';

import lottie from 'lottie-web';

import './HotspotPanel.css';
import './Scrollbar.css';

const HotspotPanel = observer((props) => {

  const hotspotData = props.data[store.currentPanelHotspotId];
  const title = hotspotData ? hotspotData.title : '';
  const copy = hotspotData ? hotspotData.copy : [];
  const imagePath = hotspotData ? hotspotData.image : null;
  const videoPath = hotspotData ? hotspotData.video : null;
  const animationPath = hotspotData ? hotspotData.animation : null;
  const link = hotspotData ? hotspotData.link : null;

  const anime = useRef(null);
  if(animationPath) {
    const thisAnimation = lottie.loadAnimation({
      container: anime.current,
      renderer: 'svg',
      loop: true,
      autoplay: false,
      path: animationPath
    });
    if(store.playAnimation) {
      thisAnimation.goToAndPlay(1, true);
    } else {
      thisAnimation.destroy();
    }    
  }

  const style = {
    transformOrigin: store.hotspotPanelOrigin[0] + 'px ' + store.hotspotPanelOrigin[1] + 'px'
  };

  const wSize = useWindowResize();

  let scrollableHeight = 0;

  if (wSize.width && wSize.height) {
    const imageHeight = wSize.width * 0.205;
    const imageMargin = 40;
    const verticalPadding = 100;
    const titleHeight = 30 + 45 + 30; // height + marginTop + marginBottom;

    scrollableHeight = wSize.height - imageHeight - imageMargin - verticalPadding - titleHeight;
  }

  return (
    <div className='perspective-container'>
      <article 
        className={ classNames('hotspot-panel', { 'visible' : store.hotspotPanelVisible }) }
        style={style}
      >
        <div className='content'>
          <CloseButton />

          <h1>{title}</h1>

          <div className='main'>
            {window.MOBILE ? (
              <>
                <div>
                  {copy.map((paragraph, i) => {
                    return (
                      <p key={i}>{paragraph}</p>
                    )
                  })}
                  {link && (
                    <p><a href={link.url} target='_blank'>{link.text}</a></p>
                  )}              
                </div>
                {imagePath && (
                  <img className="illu-img" src={imagePath} alt="" />
                )}
              </>
            ) : (
              <>
                <SimpleBar style={{ maxHeight: scrollableHeight }}>
                  {copy.map((paragraph, i) => {
                    return (
                      <p key={i}>{paragraph}</p>
                    )
                  })}
                  {link && (
                    <p><a href={link.url} target='_blank'>{link.text}</a></p>
                  )}
                </SimpleBar>
                
                {imagePath && (
                  <div className='illustration' style={
                    {
                      backgroundImage: 'url(' + imagePath + ')',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center center',
                      backgroundSize: 'cover'
                    }
                  } />
                )}

                {videoPath && (
                  <div className='video-wrapper'>
                    <video width='320' height='240' playsInline autoPlay loop muted>
                      <source src={videoPath} type='video/mp4' />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                )}

                <div ref={anime} className="lottie-animation"></div>

              </>
            )}
          </div>
        </div>
      </article>
    </div>
  )
});

export { HotspotPanel };